// Theme
export const CHANGE_THEME = 'CHANGE_THEME';
// Music
export const PLAY_MUSIC = 'PLAY_MUSIC';
export const STOP_MUSIC = "STOP_MUSIC";